// 날짜 포맷팅 함수 (YYYY-MM-DD) - 입력용
export const formatDateString = (value) => {
    if (!value) return "";

    // 숫자만 추출
    const numbers = value.replace(/\D/g, "");

    // 8자리까지만 허용 (YYYYMMDD)
    const limited = numbers.slice(0, 8);

    let formatted = limited;
    if (limited.length > 4) {
        formatted = `${limited.slice(0, 4)}-${limited.slice(4)}`;
    }
    if (limited.length > 6) {
        formatted = `${limited.slice(0, 4)}-${limited.slice(4, 6)}-${limited.slice(6)}`;
    }

    return formatted;
};

// 휴대폰 번호 포맷팅 (010-0000-0000)
export const formatPhoneNumber = (value) => {
    const raw = value.replace(/\D/g, '').slice(0, 11);
    if (raw.length < 4) return raw;
    if (raw.length < 8) return `${raw.slice(0, 3)}-${raw.slice(3)}`;
    return `${raw.slice(0, 3)}-${raw.slice(3, 7)}-${raw.slice(7)}`;
};

// [AARON] 데이터 요약 함수 (토큰 최적화)

// 1. 출석 데이터 요약
export const summarizeAttendance = (students, attendanceLogs) => {
    if (!attendanceLogs || attendanceLogs.length === 0) return "출석 기록이 아직 없습니다.";

    // 최근 4회만 분석 (날짜 역순 정렬)
    const sortedLogs = [...attendanceLogs]
        .filter(log => log.date) // 날짜 없는 데이터 제외
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, 4);

    if (sortedLogs.length === 0) return "출석 기록이 없습니다.";

    const summary = sortedLogs.map(log => {
        const statusMap = { present: [], late: [], absent: [], none: [] };

        students.forEach(s => {
            const status = log[s.id] || 'none';
            if (statusMap[status]) statusMap[status].push(s.name);
            else statusMap.none.push(s.name);
        });

        const total = students.length;
        const presentCount = statusMap.present.length;

        let details = [];
        if (statusMap.late.length > 0) details.push(`지각(${statusMap.late.join(', ')})`);
        if (statusMap.absent.length > 0) details.push(`결석(${statusMap.absent.join(', ')})`);
        if (statusMap.none.length > 0 && statusMap.none.length < total) details.push(`미확인(${statusMap.none.length}명)`); // 전원이 미확인이면 생략

        const detailsStr = details.length > 0 ? `- 명단: ${details.join(', ')}` : "- 특이사항 없음";

        // AI가 읽기 쉽게 문장형에 가깝게 변환
        return `📅 ${log.date}: 총 ${total}명 중 ${presentCount}명 출석. ${detailsStr}`;
    }).join("\n");

    return `[최근 4주 출석 현황]\n${summary}`;
};

// 2. 재정 데이터 요약
export const summarizeFinance = (finances) => {
    if (!finances || finances.length === 0) return "재정 기록 없음";

    const income = finances.filter(f => f.type === 'income').reduce((acc, curr) => acc + (parseInt(curr.amount) || 0), 0);
    const expense = finances.filter(f => f.type === 'expense').reduce((acc, curr) => acc + (parseInt(curr.amount) || 0), 0);

    // 최근 거래 5건만
    const recentTx = finances.slice(0, 5).map(f =>
        `[${f.date}] ${f.description} (${parseInt(f.amount).toLocaleString()}원, ${f.type === 'income' ? '수입' : '지출'})`
    ).join("\n");

    return `총수입: ${income.toLocaleString()}원, 총지출: ${expense.toLocaleString()}원, 잔액: ${(income - expense).toLocaleString()}원\n최근 내역:\n${recentTx}`;
};

// 3. 일정 요약 (다가오는 일정만)
export const summarizeSchedule = (schedules) => {
    if (!schedules || schedules.length === 0) return "예정된 일정 없음";

    const today = new Date();
    // 미래 일정만 필터링 후 날짜순 정렬
    const upcoming = schedules
        .filter(s => new Date(s.date) >= today)
        .sort((a, b) => new Date(a.date) - new Date(b.date))
        .slice(0, 5); // 5개만

    if (upcoming.length === 0) return "소화할 예정 없음";

    return upcoming.map(s => `[${s.date}] ${s.title} (${s.type})`).join("\n");
};

// 4. 심방 데이터 요약
export const summarizeVisitLogs = (students, visitLogs) => {
    if (!visitLogs || visitLogs.length === 0) return "심방 기록 없음";

    // 최신순 정렬 후 최근 5개만
    const sorted = [...visitLogs]
        .filter(v => v.date)
        .sort((a, b) => new Date(b.date) - new Date(a.date))
        .slice(0, 5);

    if (sorted.length === 0) return "심방 기록 없음";

    return sorted.map(v => {
        const studentName = students.find(s => s.id === v.studentId)?.name || "알 수 없는 학생";
        return `[${v.date}] ${studentName} 심방: ${v.content || '내용 없음'} (${v.type || '일반'})`;
    }).join("\n");
};
